import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Copy, ExternalLink } from 'lucide-react';
import ReportarPago from './ReportarPago';
import { cop } from './tiendaUtils';

const copiar = async (texto) => {
  try { await navigator.clipboard.writeText(texto); toast.success('Valor copiado'); } catch { toast.error('No se pudo copiar'); }
};

export default function PagoOnline({ ordenId, valor, enlace, instrucciones, reportePendiente, onReportado }) {
  const [reportado, setReportado] = useState(Boolean(reportePendiente));
  useEffect(() => setReportado(Boolean(reportePendiente)), [reportePendiente]);

  if (reportado) {
    return (
      <p className="rounded-xl border border-blue-500/30 bg-blue-500/10 p-4 text-sm text-blue-200" data-testid="pago-en-verificacion">
        Recibimos tu reporte de pago. Lo estamos verificando y te avisaremos cuando quede confirmado.
      </p>
    );
  }
  return (
    <div className="space-y-4" data-testid="pago-online">
      <div className="rounded-xl border border-[#C9A962]/30 bg-[#C9A962]/10 p-4 text-center">
        <p className="text-xs uppercase tracking-wider text-[#C9A962]">Valor exacto a pagar</p>
        <p className="mt-1 text-3xl font-semibold text-white" data-testid="pago-valor">{cop(valor)} <span className="text-base font-normal text-zinc-400">COP</span></p>
        <button type="button" onClick={() => copiar(String(Math.round(valor)))} className="mt-2 inline-flex items-center gap-1.5 text-xs text-[#C9A962] hover:underline" data-testid="pago-copiar-valor">
          <Copy className="h-3.5 w-3.5" />Copiar valor
        </button>
      </div>
      <p className="text-sm text-zinc-300">En la página de Bold escribe exactamente este valor en «¿Cuánto quieres pagar?».</p>
      {instrucciones && <p className="whitespace-pre-line rounded-xl bg-zinc-800/50 p-4 text-sm leading-relaxed text-zinc-300" data-testid="pago-instrucciones">{instrucciones}</p>}
      <a href={enlace} target="_blank" rel="noopener noreferrer" className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#C9A962] py-3.5 font-semibold text-black transition-colors hover:bg-[#D4B872]" data-testid="pago-ir-bold">
        Pagar con Bold<ExternalLink className="h-4 w-4" />
      </a>
      <ReportarPago ordenId={ordenId} onReportado={() => { setReportado(true); onReportado?.(); }} />
    </div>
  );
}
